import styled from 'foundations-theming/utils';
export const InterstitialTileTitle = styled.div.withConfig({
  displayName: "SharedComponents__InterstitialTileTitle",
  componentId: "xhf7tb-0"
})(["font-weight:600;font-size:20px;"]);
export const StyledTitleContainer = styled.span.withConfig({
  displayName: "SharedComponents__StyledTitleContainer",
  componentId: "xhf7tb-1"
})(["margin-bottom:8px;"]);